import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GET_FILE_INFO } from 'services/api';

const StripeDocument = ({ document, disputeId, onDeleteClick }) => {
  const [localDocument, setLocalDocument] = React.useState();
  const handleDelete = () => {
    onDeleteClick(document.id);
  };

  React.useEffect(() => {
    if (!document.name) {
      GET_FILE_INFO(disputeId, document.id).then((document) => {
        setLocalDocument(document);
      });
    }
  }, [disputeId, document.id, document.name]);

  return (
    <div className="card bg-white py-4 px-7 lg:w-8/12" data-testid="file-info">
      <div className="flex items-center justify-between">
        <FontAwesomeIcon
          icon={['far', 'file']}
          size="sm"
          className="whitespace-nowrap"
        />
        <p className="ml-5 inline-block flex-1 truncate text-xs font-bold text-javelin-gray-dark">
          {localDocument?.filename ?? document.name}
        </p>
        <div className="pl-4">
          <FontAwesomeIcon
            icon={['far', 'trash-alt']}
            size="sm"
            className="cursor-pointer text-javelin-gray-light"
            onClick={handleDelete}
            data-testid="delete-icon"
          />
        </div>
      </div>
    </div>
  );
};

export default StripeDocument;
